import { ModalM } from "@common/components/modal/ModalM"
import TextM from "@common/components/text/TextM"
import { theme } from "@common/theme/theme"
import React, { useState } from "react"
import { View } from "react-native"
import { connect } from "react-redux"
import IconButtonM from "../../../common/components/button/IconButtonM"
import { CustomIconButton } from "../../../common/header/LiveModeFooter"
import SelfCreateActivityButton from "../SelfCreateActivityButton"
import { apiIdle, apiRequest } from "../../../data/redux/actions/api"
import { authService } from "../../../data/services/authService"
import { hasRole } from "../../../data/utility/ability"
import GenerateActivityModal from "../../../tutor/students/GenerateActivityModal"
import TodoListModalItems from "./TodoListModalItems"

const TodoListModal = (props) => {
    const {
        visible,
        onClose,
        todoActivities = [],
        student,
        navigation,
        route,
    } = props

    const getUserService = authService.getUser
    const getUserParams = {}

    const isStudentSelfCreate =
        hasRole(student, "student") && !props.isParentMode

    const [showGenerateModal, setShowGenerateModal] = useState(false)

    return (
        <ModalM
            visible={visible}
            onDismiss={onClose}
            style={{
                height: "80%",
                maxWidth: "90%",
            }}
        >
            <View
                style={{
                    width: "100%",
                    padding: 10,
                    flex: 1,
                }}
            >
                <View style={{ width: "100%", flex: 1 }}>
                    <View
                        style={{
                            width: "100%",
                            flexDirection: "row",
                            alignItems: "center",
                            justifyContent: "center",
                        }}
                    >
                        <IconButtonM
                            icon="times"
                            iconColor={theme.colors.primary}
                            size={32}
                            onPress={onClose}
                        />
                        <View
                            style={{
                                flex: 1,
                                alignItems: "center",
                                justifyContent: "center",
                            }}
                        >
                            <TextM
                                fontWeight="ExtraBold"
                                fontSize={24}
                                color={theme.colors.primary}
                                style={{
                                    flex: 1,
                                    textAlign: "center",
                                    marginBottom: 4,
                                }}
                                wrap
                            >
                                Activités
                            </TextM>
                        </View>
                        <CustomIconButton
                            icon="sync-alt"
                            iconColor={theme.colors.primary}
                            size={28}
                            disabled={props.getUserRequest}
                            loading={props.getUserRequest}
                            onPress={() =>
                                props.apiRequest(getUserService, getUserParams)
                            }
                        />
                    </View>
                    <TodoListModalItems
                        todoList={todoActivities}
                        student={student}
                        nav={navigation}
                        closeModal={onClose}
                        route={route}
                    />
                    {isStudentSelfCreate && (
                        <SelfCreateActivityButton
                            onPress={() => setShowGenerateModal(true)}
                            style={{ marginTop: 8, marginBottom: 4 }}
                        />
                    )}
                </View>
            </View>
            {showGenerateModal && (
                <GenerateActivityModal
                    isOpen={showGenerateModal}
                    onClose={() => setShowGenerateModal(false)}
                    student={student}
                    schoolSubjects={props.schoolSubjects}
                    selfCreate={isStudentSelfCreate}
                    nav={navigation}
                />
            )}
        </ModalM>
    )
}

const mapStateToProps = (state) => ({
    getUserRequest: state.api.getUser?.request,
    isParentMode: state.data.family?.isParentMode,
    schoolSubjects: state.data.staticData?.school_subjects,
})

const mapDispatchToProps = {
    apiRequest,
    apiIdle,
}

export default connect(mapStateToProps, mapDispatchToProps)(TodoListModal)
